import { useMap } from "react-leaflet";
import { useEffect } from "react";
import L from "leaflet";

interface ZoomControlProps {
  position?: L.ControlPosition;
}

const ZoomControl: React.FC<ZoomControlProps> = ({ position = "topleft" }) => {
  const map = useMap();

  useEffect(() => {
    if (!map || !map.getContainer()) return;

    const zoom = L.control.zoom({ position });
    zoom.addTo(map);

    return () => {
      map.removeControl(zoom);
    };
  }, [map, position]);

  return null;
};

export default ZoomControl;
